<template>
  <div class="tb">
    <section class="tb-1">
      <h1 class="tb-title">Thomas Bros. Garage</h1>
      <h2 class="tb-subtitle">Investing in the future, on day zero.</h2>
      <a class="tb-action" href="mailto:dave@thomasbrothersgarage.com">Get in Touch</a>
    </section>
    <section class="tb-2">
      <div class="tb-2__container">
        <div class="logo-container">
          <img class="logo-image" src="../assets/img/go-logo.jpg" alt="">
        </div>
        <div class="content">
          <aside>
            Recent Investment
          </aside>
          <h1>GO Sats</h1>
          <p>Making small scale satellites available to everyone.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/styles/app.scss";

  .tb {
    overflow: auto;
    display: flex;
    align-items: center;
    height: 100%;
  }

  .tb-title {
    color: transparent;
    background-image: url('../assets/img/tb-logo.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 20rem;
    text-align: center;
  }

  .tb-1,
  .tb-2 {
    width: 50%;
    float: left;
    position: relative;
  }

  .tb-2 {
    background-image: url('../assets/img/rocket.png');
    background-size: cover;
    height: 100%;
    display: flex;
    align-items: flex-end;
  }

  .tb-2__container {
    padding-bottom: 6rem;
    max-width: 42rem;
    margin-left: auto;
    margin-right: auto;
    display: flex;

    .content {
      text-align: left;
      margin-left: 2rem;

      aside {
        @include caps;
        font-size: 1rem;
        color: white;
        margin-bottom: .75rem;
      }

      h1 {
        font-size: 3rem;
        color: white;
        font-weight: 900;
        margin-bottom: .25rem;
      }

      p {
        max-width: 25rem;
        font-size: 2rem;
        color: white;
        line-height: 1.35;
      }
    }
  }

  .logo-container {
    height: 8.25rem;
    width: 8.25rem;
    background-image: url('../assets/img/container.svg');
    background-size: contain;
    display: flex;
    align-items: center;
  }

  .logo-image {
    display: block;
    width: 80%;
    margin: auto;
  }

  .tb-subtitle {
    font-size: 2rem;
    max-width: 20rem;
    margin: 1rem auto;
  }

  .tb-action {
    @include caps;
    position: absolute;
    left: 50%;
    background: $color-main;
    text-decoration: none;
    padding: .45rem 1rem .3rem;
    display: inline-block;
    transform: translate3d(-50%, .5rem, 0) rotate(-4deg);
    transition: .1s ease all;
    border-radius: 4px;

    &:hover {
      transform: translate3d(-50%, .5rem, 0) rotate(0);
      transition: .22s ease all;
      padding: .75rem 1.25rem .5rem;
    }
  }

  @media screen and (max-width: 1200px) {
    .tb {
      display: block;
    }

    .tb-1,
    .tb-2 {
      width: 100%;
    }

    .tb-1 {
      box-sizing: border-box;
      padding: 3rem;
      margin-bottom: 5rem;
    }

    .tb-title {
      height: 15rem;
    }

    .tb-2__container {
      display: block;

      .logo-container {
        margin-bottom: 1.5rem;
      }

      .content {
        margin-left: 0;
      }
    }
  }

</style>
